const getEnumKeys = <T extends object>(
    enumToDeconstruct: T
): Array<keyof typeof enumToDeconstruct> => {
    return Object.keys(enumToDeconstruct).filter(x => !(parseInt(x) >= 0)) as Array<
        keyof typeof enumToDeconstruct
    >;
};
export default getEnumKeys;
